/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Focus_Full_BodyInputs */

const en_us2_quick_workout_focus_full_body = /** @type {(inputs: Quick_Workout_Focus_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full body`)
};

const pt_br2_quick_workout_focus_full_body = /** @type {(inputs: Quick_Workout_Focus_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo todo`)
};

const es_419_quick_workout_focus_full_body = /** @type {(inputs: Quick_Workout_Focus_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerpo completo`)
};

const pt_pt2_quick_workout_focus_full_body = /** @type {(inputs: Quick_Workout_Focus_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo inteiro`)
};

const fr_fr2_quick_workout_focus_full_body = /** @type {(inputs: Quick_Workout_Focus_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corps entier`)
};

const de_de2_quick_workout_focus_full_body = /** @type {(inputs: Quick_Workout_Focus_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganzkörper`)
};

const it_it2_quick_workout_focus_full_body = /** @type {(inputs: Quick_Workout_Focus_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total body`)
};

/**
* | output |
* | --- |
* | "Full body" |
*
* @param {Quick_Workout_Focus_Full_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_focus_full_body = /** @type {((inputs?: Quick_Workout_Focus_Full_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Focus_Full_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_focus_full_body(inputs)
	if (locale === "es-419") return es_419_quick_workout_focus_full_body(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_focus_full_body(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_focus_full_body(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_focus_full_body(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_focus_full_body(inputs)
	return en_us2_quick_workout_focus_full_body(inputs)
});
export { quick_workout_focus_full_body as "quick-workout.focus_full_body" }